import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 sm:px-6 bg-brand-dark text-center text-white/60 text-[10px] sm:text-xs" data-id="element-72">
      <p className="leading-snug max-w-2xl mx-auto font-medium mb-4" data-id="element-73">
        © {new Date().getFullYear()} Swimming Coach Ready™ — All Rights
        Reserved. The content of this page is for educational purposes only and
        does not replace professional aquatic certification requirements. Always
        follow appropriate safety guidelines when working in aquatic
        environments.
      </p>
      <div className="flex justify-center gap-3 sm:gap-4 font-bold tracking-wide uppercase" data-id="element-74">
        <a href="#" className="hover:text-brand-pool transition-colors" data-id="element-75">
          Terms & Conditions
        </a>
        <span className="text-white/20" data-id="element-76">·</span>
        <a href="#" className="hover:text-brand-pool transition-colors" data-id="element-77">
          Privacy Policy
        </a>
        <span className="text-white/20" data-id="element-78">·</span>
        <a href="#" className="hover:text-brand-pool transition-colors" data-id="element-79">
          Contact
        </a>
      </div>
    </footer>;
}